import React, { useState } from 'react'
import _ from 'lodash'
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core'
import { postAccountSettings } from '../../lib/apigateway/settings'
import { postUserFeedback } from '../../lib/apigateway/feedback'
import { useGlobalStateContext } from '../../contexts'

const Setup = () => {
  const [value, setValue] = useState('')
  const [text, setText] = useState('')

  const { globalState: { user, settings } } = useGlobalStateContext()

  const handleRadioChange = (event) => {
    setValue(event.target.value)
  }

  const handleTextChange = (e) => {
    setText(e.target.value)
  }

  const handleSubmit = async () => {
    const userSettings = _.cloneDeep(settings)
    userSettings.newUser = false
    userSettings.questionnaire = { skill: value }
    await postAccountSettings(user.username, userSettings)
    if (text) {
      await postUserFeedback(user.username, 'questionnaire', text)
    }
    window.location.reload()
  }

  return (
    <Paper>
      <Box p={3}>
        <Box fontSize={40}>
          Welcome to&nbsp;
          <Box component="span" color="primary.main">SIP</Box>
        </Box>
        <Box fontWeight={300}>One last thing!</Box>

        <Box mt={4} fontSize={20} fontWeight={400}>Which description fits you best?</Box>
        <Box mt={2}>
          <FormControl component="fieldset">
            <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleRadioChange}>
              <FormControlLabel value="new" control={<Radio />} label="I don't know Hangul (Korean alphabet) and am a complete beginner" />
              <FormControlLabel value="beginner" control={<Radio />} label="I know Hangul (Korean alphabet) and some basic grammar" />
              <FormControlLabel value="intermediate" control={<Radio />} label="I have some experience learning Korean and practicing listening" />
              <FormControlLabel value="advanced" control={<Radio />} label="I have been studying intensively and can understand most of the content I consume" />
            </RadioGroup>
          </FormControl>
        </Box>
        <Box mt={3} mb={1} fontSize={20} fontWeight={400}>
          Why do you want to learn Korean? (Optional)
        </Box>
        <Box>
          <TextField
            value={text}
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            onChange={handleTextChange}
          />
        </Box>

        <Box display="flex" justifyContent="center" mt={2}>
          <Button onClick={handleSubmit} color="secondary" variant="contained" disabled={!value}>
            Submit
          </Button>
        </Box>
      </Box>
    </Paper>
  )
}

export default Setup
